import React, { useCallback, useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import Tooltip from 'antd/lib/tooltip';
import { parseAvatar } from '../services/utilities';

import {
	request,
	formatPatientId,
	getAge,
	patientname,
	confirmAction,
	formatToStandardDate,
	confirmImmunizationAction,
	confirmActionAlt,
} from '../services/utilities';
import { patientAPI, admissionAPI, USER_RECORD, antenatalAPI, labourAPI } from '../services/constants';
import { notifySuccess, notifyError } from './../services/notify';
import { startBlock, stopBlock } from '../actions/redux-block';
import { formatCurrency } from '../services/utilities';
import { messageService } from '../services/message';
import ViewAlerts from './Modals/ViewAlerts';
import ViewProfileImage from './Modals/ViewProfileImage';
import ModalDischargePatient from './Modals/ModalDischargePatient';
import ModalDischargeStatus from './Modals/ModalDischargeStatus';
import ModalFinishDischarge from './Modals/ModalFinishDischarge';
import PatientForm from './Modals/PatientForm';
import DischargeBlock from './DischargeBlock';
import { setPatientRecord, toggleProfile } from '../actions/user';
import { setPatientData, toggleSidepanel } from '../actions/sidepanel';
import SSRStorage from '../services/storage';
import { hasCloseAncPermission } from '../permission-utils/antenatal';
import CreateNote from './Modals/CreateNote';
import PatientProfile from './Modals/PatientProfile';
import { hasCloseLabourPermission } from '../permission-utils/labour';
import { SendUpdateLink } from './Modals/SendUpdateLink';
import { hasCancelIVFPermission, hasCloseIVFPermission, hasContinueIVFPermission } from '../permission-utils/ivf';
import { hasViewPatientRecordsPermission } from '../permission-utils/patient';
import { C } from 'react-select/dist/index-c7a4d7ce.esm';
import EnrollImmunizationModal from './Patient/Modals/EnrolImmunizationModal';
import { confirmIVFStatusUpdate } from '../pages/IVF/modal/markIVFStatus';
import { Droplets, ShieldCheck } from 'lucide-react';

const storage = new SSRStorage();

const UserItem = ({ icon, label, value }) => {
	return (
		label !== '' && (
			<>
				<th className="pb-50">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						width="14px"
						height="14px"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
						className={`mr-75 feather feather-${icon || 'user'}`}
					>
						<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
						<circle cx="12" cy="7" r="4"></circle>
					</svg>
					<span className="font-weight-normal">{label}</span>
				</th>
				<td className="pb-50">{value}</td>
			</>
		)
	);
};

const NextApp = ({ label, value }) => {
	return (
		<>
			<th className="pb-50">
				<i className="mr-75 picons-thin-icon-thin-0023_calendar_month_day_planner_events" />

				<span className="font-weight-normal">{label}</span>
			</th>
			{/* <td className="py-2 bg-success text-white rounded px-2">{value}</td> */}
			<td className="pb-50">{value}</td>
		</>
	);
};

const ProfileBlock = ({ location, history, patient: pat, hasButtons, canAdmit, canDischarge, canNewNote, ivfData: ivf, opdItem }) => {
	const [alerts, setAlerts] = useState([]);
	const [showModal, setShowModal] = useState(false);
	const [editModal, setEditModal] = useState(false);
	const [admissionId, setAdmissionId] = useState(null);
	const [amount, setAmount] = useState(null);
	const [admissionDischarge, setAdmissionDischarge] = useState(false);
	const [nicuDischarge, setNicuDischarge] = useState(false);
	const [nicuId, setNicuId] = useState(null);
	const [dischargeType, setDischargeType] = useState('');
	const [showDischargeStatusModal, setShowDischargeStatusModal] = useState(false);
	const [pendingDischargeNote, setPendingDischargeNote] = useState('');
	const [admissionFinishDischarge, setAdmissionFinishDischarge] = useState(false);
	const [nicuFinishDischarge, setNicuFinishDischarge] = useState(false);
	const [admission, setAdmission] = useState(null);
	const [alertShown, setAlertShown] = useState(false);
	const [showNoteModal, setShowNoteModal] = useState(false);
	const [showProfileModal, setShowProfileModal] = useState(false);
	const [patient, setPatient] = useState(pat);
	const [ivfData, setIvfData] = useState(ivf);
	const [patientIsUpdated, setPatientIsUpdated] = useState(false);
	const [emailModalOpen, setEmailModalOpen] = useState(false);
	const [appointmentCount, setAppointmentCount] = useState(0);
	const [hasInitialized, setHasInitialized] = useState(false);
	const [startDate, setStartDate] = useState('');
	const [showImmunizationModal, setShowImmunizationModal] = useState(false);
	const [immunizationStartDate, setImmunizationStartDate] = useState(null);
	const [bloodTransfusionAlertShown, setBloodTransfusionAlertShown] = useState(false);
	const [showImageModal, setShowImageModal] = useState(false);

	const dispatch = useDispatch();

	// console.log(patient?.lastAppointment, 'setPatientto view');
	// {moment(patient?.lastAppointment?.next_appointment).format('dddd, MMMM DD, YYYY')}

	const user = useSelector(state => state.user.profile);
	console.log(patient, 'patient in profile block');

	const getAlerts = useCallback(async () => {
		try {
			const url = `patient/${patient.id}/alerts?category=normal`;
			const rs = await request(url, 'GET', true);
			setAlerts(rs);

			const uri = `patient/${patient.id}/outstandings`;
			const res = await request(uri, 'GET', true);
			setAmount(res);

			if (patient.admission_id) {
				const auri = `patient/${patient.admission_id}/admission`;
				const _res = await request(auri, 'GET', true);
				setAdmission(_res);
			}
		} catch (error) {
			notifyError('Error fetching alerts');
		}
	}, [patient]);

	const getPatientDetails = useCallback(async () => {
		try {
			const url = `patient/find?id=${patient.id}`;
			const rs = await request(url, 'GET', true);
			if (rs?.length) {
				setPatient(rs[0]);
				setPatientIsUpdated(true);
			}
		} catch (error) {
			notifyError('Error fetching patient data');
		}
	}, [patient]);

	// TEMP - to be removed
	// useEffect(() => {
	// 	getAlerts();
	// 	if (!patientIsUpdated) {
	// 		getPatientDetails();
	// 	}
	// 	if (!alertShown) {
	// 		showAlerts();
	// 	}
	// 	if (patient) {
	// 		getAppointmentData();
	// 	}
	// }, [alertShown, getAlerts, patientIsUpdated, getPatientDetails, patient]);

	useEffect(() => {
		if (!hasInitialized && patient) {
			getAlerts();
			if (!patientIsUpdated) {
				getPatientDetails();
			}
			if (!alertShown) {
				showAlerts();
			}
			getAppointmentData();
			setHasInitialized(true);
		}
	}, [hasInitialized, patient]);

	useEffect(() => {
		if (patient?.refuse_blood_transfusion && !bloodTransfusionAlertShown) {
			setBloodTransfusionAlertShown(true);
		}
	}, [patient?.refuse_blood_transfusion]);

	useEffect(() => {
		const subscription = messageService.getMessage().subscribe(message => {
			if (message !== '') {
				const { type, data } = message.text;

				if (type === 'refresh' || type === 'refresh-alerts') {
					getAlerts();
				} else if (type === 'balance') {
					setAmount(data);
				} else if (type === 'refresh-alert') {
					getAlerts();

					setTimeout(() => {
						document.body.classList.add('modal-open');
						setShowModal(true);
					}, 1000);
				}
			}
		});

		return () => {
			subscription.unsubscribe();
		};
	}, [getAlerts]);

	const enrollImmunization = () => {
		setShowImmunizationModal(true);
	};

	const onEnrollImmunization = async date => {
		try {
			dispatch(startBlock());
			const data = {
				patient_id: patient.id,
				start_date: date || startDate || patient.date_of_birth,
			};
			const url = `${patientAPI}/immunization/enroll`;
			const rs = await request(url, 'POST', true, data);
			dispatch(stopBlock());
			if (rs.success) {
				notifySuccess(`you have enrolled ${patient.other_names} into immunization`);
				messageService.sendMessage({
					type: 'update-patient',
					data: { ...patient, immunization: rs.records },
				});
				dispatch(setPatientRecord({ ...patient, immunization: rs.records }));
				history.push(`${location.pathname}#immunization-chart`);
				setShowImmunizationModal(false); // Close modal on success
			} else {
				notifyError(rs.message);
			}
		} catch (error) {
			dispatch(stopBlock());
			notifyError(error.message || 'Could not add leave request');
		}
	};

	const dob = patient.date_of_birth ? moment(formatToStandardDate(patient.date_of_birth)).format('DD-MMM-YYYY') : '';

	const showAlerts = () => {
		const canViewAlerts = user.role.slug === 'it-admin' || user.role.slug === 'medical-director' || user.role.slug === 'doctor';

		if (!canViewAlerts) return;
		document.body.classList.add('modal-open');
		setShowModal(true);
		setAlertShown(true);
	};

	const editPatient = () => {
		document.body.classList.add('modal-open');
		setEditModal(true);
	};

	const closeModal = () => {
		setShowModal(false);
		setEditModal(false);
		setShowNoteModal(false);
		setShowProfileModal(false);
		document.body.classList.remove('modal-open');
	};

	const startDischarge = id => {
		setAdmissionId(id);
		document.body.classList.add('modal-open');
		setAdmissionDischarge(true);
		setDischargeType('admission');
	};

	const startNicuDischarge = id => {
		setNicuId(id);
		document.body.classList.add('modal-open');
		setNicuDischarge(true);
		setDischargeType('nicu');
	};

	const onStartDischarge = async (id, param, type) => {
		try {
			dispatch(startBlock());
			const api = type === 'nicu' ? 'nicu' : admissionAPI;
			const url = `${api}/${id}/start-discharge`;
			const rs = await request(url, 'PUT', true, { ...param });
			dispatch(stopBlock());
			if (rs.success) {
				const result = rs.admission;

				const newPatient = {
					...patient,
					admission: type === 'admission' ? result : null,
					nicu: type === 'nicu' ? result : null,
				};
				dispatch(setPatientData(newPatient));

				messageService.sendMessage({
					type: 'update-patient',
					data: newPatient,
				});

				const admission = {
					id: result.id,
					start_discharge: result.start_discharge,
					start_discharge_date: result.start_discharge_date,
					start_discharge_by: result.start_discharge_by,
					patient: newPatient,
				};

				messageService.sendMessage({
					type: `${type === 'nicu' ? 'nicu' : 'admission'}-discharge`,
					admission,
				});

				notifySuccess('Patient discharge initiated');
				closeDischarge();
			} else {
				notifyError(rs.message);
			}
		} catch (error) {
			dispatch(stopBlock());
			notifyError(error.message || 'Could not initiate discharge');
		}
	};

	const onSubmitDischargeNote = (id, param, type) => {
		setPendingDischargeNote(param.note);
		setAdmissionDischarge(false);
		setNicuDischarge(false);
		setShowDischargeStatusModal(true);
	};

	const confirmDischargeStatus = status => {
		setShowDischargeStatusModal(false);
		const id = dischargeType === 'nicu' ? nicuId : admissionId;
		onStartDischarge(id, { note: pendingDischargeNote, discharge_type: status }, dischargeType);
	};

	const finishDischarge = id => {
		setAdmissionId(id);
		document.body.classList.add('modal-open');
		setAdmissionFinishDischarge(true);
		setDischargeType('admission');
	};

	const finishNicuDischarge = id => {
		setNicuId(id);
		document.body.classList.add('modal-open');
		setNicuFinishDischarge(true);
		setDischargeType('nicu');
	};

	const getAppointmentData = async () => {
		try {
			const uri = `front-desk/appointments/aggregation/${patient.id}`;
			const rs = await request(uri, 'GET', true);
			if (rs.success) {
				setAppointmentCount(rs.count);
			}
		} catch (error) {
			console.log(error);
		}
	};

	const onCompleteDischarge = async (id, param, type) => {
		try {
			dispatch(startBlock());
			const api = type === 'nicu' ? 'nicu' : admissionAPI;
			const url = `${api}/${id}/complete-discharge`;
			const rs = await request(url, 'PUT', true, { ...param });
			dispatch(stopBlock());
			if (rs.success) {
				const result = rs.admission;

				const newPatient = {
					...patient,
					admission_id: null,
					nicu_id: null,
					admission: null,
					nicu: null,
				};
				dispatch(setPatientRecord(newPatient));

				messageService.sendMessage({
					type: 'update-patient',
					data: newPatient,
				});

				const admission = {
					id: result.id,
					date_discharged: result.date_discharged,
					dischargedBy: result.dischargedBy,
					status: 1,
					lastChangedBy: result.lastChangedBy,
					patient: newPatient,
				};

				messageService.sendMessage({
					type: `${type === 'nicu' ? 'nicu' : 'admission'}-finish-discharge`,
					admission,
				});

				notifySuccess('Patient discharged');
				closeDischarge();

				storage.removeItem(USER_RECORD);
				dispatch(toggleProfile(false));
			} else {
				notifyError(rs.message);
			}
		} catch (error) {
			dispatch(stopBlock());
			notifyError(error.message || 'Could not discharge patient');
		}
	};

	const closeDischarge = () => {
		setAdmissionDischarge(false);
		setNicuDischarge(false);
		setAdmissionFinishDischarge(false);
		setNicuFinishDischarge(false);
		setShowDischargeStatusModal(false);
		setPendingDischargeNote('');
		document.body.classList.remove('modal-open');
		setAdmissionId(null);
		setNicuId(null);
	};

	const toggleBloodTransfusion = async () => {
		const newValue = !patient.refuse_blood_transfusion;
		confirmActionAlt(
			async () => {
				try {
					dispatch(startBlock());
					const url = `patient/${patient.id}/refuse-blood-transfusion`;
					const rs = await request(url, 'PATCH', true, { refuse_blood_transfusion: newValue });
					dispatch(stopBlock());
					if (rs.success) {
						const updatedPatient = { ...patient, refuse_blood_transfusion: newValue };
						setPatient(updatedPatient);
						dispatch(setPatientRecord(updatedPatient));
						messageService.sendMessage({ type: 'update-patient', data: updatedPatient });
						notifySuccess(newValue ? 'Patient marked as refusing blood transfusion' : 'Blood transfusion restriction removed');
					} else {
						notifyError(rs.message || 'Could not update');
					}
				} catch (error) {
					dispatch(stopBlock());
					notifyError(error.message || 'Could not update');
				}
			},
			null,
			newValue ? 'Mark this patient as refusing blood transfusion?' : 'Remove blood transfusion restriction for this patient?',
			'Are you sure?'
		);
	};

	const confirm = data => {
		confirmAction(data === 'enable' ? enablePatient : disablePatient, null, `You want to ${data} this patient profile?`, 'Are you sure?');
	};

	const deceasedAction = data => {
		confirmAction(
			data === 'deceased' ? markPatientAdDeceased : markPatientAsAlive,
			null,
			`You want to mark this patient as ${data}?`,
			'Are you sure?'
		);
	};

	const enablePatient = async () => {
		try {
			dispatch(startBlock());
			const url = `patient/${patient.id}/enable`;
			const rs = await request(url, 'POST', true);
			dispatch(stopBlock());
			if (rs.success) {
				const newPatient = rs.patient;

				messageService.sendMessage({
					type: 'update-patient',
					data: { ...patient, is_active: newPatient.is_active },
				});

				dispatch(setPatientRecord({ ...patient, is_active: newPatient.is_active }));
			} else {
				notifyError(rs.message || 'could not enable patient');
			}
		} catch (e) {
			console.log(e);
			dispatch(stopBlock());
			notifyError(e.message || 'could not enable patient');
		}
	};

	const disablePatient = async () => {
		try {
			dispatch(startBlock());
			const url = `patient/${patient.id}/disable`;
			const rs = await request(url, 'POST', true);
			dispatch(stopBlock());
			if (rs.success) {
				const newPatient = rs.patient;

				messageService.sendMessage({
					type: 'update-patient',
					data: { ...patient, is_active: newPatient.is_active },
				});

				dispatch(setPatientRecord({ ...patient, is_active: newPatient.is_active }));
			} else {
				notifyError(rs.message || 'could not disable patient');
			}
		} catch (e) {
			console.log(e);
			dispatch(stopBlock());
			notifyError(e.message || 'could not disable patient');
		}
	};

	const markPatientAdDeceased = async () => {
		try {
			dispatch(startBlock());
			const url = `patient/mark/deceased/${patient.id}`;

			const payload = { deceased: true };

			const rs = await request(
				url,
				'PATCH',
				true
				// payload
			);
			dispatch(stopBlock());

			if (rs.success) {
				setPatient({ ...patient, deceased: rs.result.deceased, is_active: rs.result.is_active });
				const newPatient = rs.result;

				messageService.sendMessage({
					type: 'update-patient',
					data: { ...patient, deceased: newPatient.deceased },
				});

				dispatch(setPatientRecord({ ...patient, deceased: newPatient.deceased }));
			} else {
				notifyError(rs.message || 'Could not mark patient as Deceased');
			}
		} catch (e) {
			console.log(e);
			dispatch(stopBlock());
			notifyError(e.message || 'Could not mark patient as alive');
		}
	};

	const markPatientAsAlive = async () => {
		try {
			dispatch(startBlock());
			const url = `patient/mark/deceased/${patient.id}`;

			const payload = { deceased: false };

			const rs = await request(
				url,
				'PATCH',
				true
				// payload
			);
			dispatch(stopBlock());

			if (rs.success) {
				const newPatient = rs.patient;

				messageService.sendMessage({
					type: 'update-patient',
					data: { ...patient, is_active: newPatient.is_active },
				});

				dispatch(setPatientRecord({ ...patient, is_active: newPatient.is_active }));
			} else {
				notifyError(rs.message || 'Could not update patient status');
			}
		} catch (e) {
			console.log(e);
			dispatch(stopBlock());
			notifyError(e.message || 'Could not update patient status');
		}
	};

	const doCloseANC = async id => {
		try {
			dispatch(startBlock());
			const url = `${antenatalAPI}/${id}/close`;
			const rs = await request(url, 'PUT', true, {});
			dispatch(stopBlock());
			if (rs.success) {
				const result = rs.enrollment;

				const newPatient = {
					...patient,
					antenatal_id: null,
				};
				dispatch(setPatientRecord(newPatient));

				messageService.sendMessage({
					type: 'update-patient',
					data: newPatient,
				});

				const enrollment = {
					id: result.id,
					date_closed: result.date_closed,
					closedBy: result.closedBy,
					status: 1,
					lastChangedBy: result.lastChangedBy,
					patient: newPatient,
				};

				messageService.sendMessage({
					type: 'anc',
					data: enrollment,
				});

				notifySuccess('Antental closed');

				storage.removeItem(USER_RECORD);
				dispatch(toggleProfile(false));
			} else {
				notifyError(rs.message);
			}
		} catch (error) {
			dispatch(stopBlock());
			notifyError(error.message || 'Could not close antenatal');
		}
	};

	const closeAnc = id => {
		confirmAction(doCloseANC, id, `You want to close antenatal?`, 'Are you sure?');
	};

	const doCloseLabour = async id => {
		try {
			dispatch(startBlock());
			const url = `${labourAPI}/${id}/close`;
			const rs = await request(url, 'PUT', true, {});
			dispatch(stopBlock());
			if (rs.success) {
				const result = rs.enrollment;

				const newPatient = {
					...patient,
					labour_id: null,
				};
				dispatch(setPatientRecord(newPatient));

				messageService.sendMessage({
					type: 'update-patient',
					data: newPatient,
				});

				const enrollment = {
					id: result.id,
					date_closed: result.date_closed,
					closedBy: result.closedBy,
					status: 1,
					lastChangedBy: result.lastChangedBy,
					patient: newPatient,
				};

				messageService.sendMessage({
					type: 'labour',
					data: enrollment,
				});

				notifySuccess('Labour Management closed');

				storage.removeItem(USER_RECORD);
				dispatch(toggleProfile(false));
			} else {
				notifyError(rs.message);
			}
		} catch (error) {
			dispatch(stopBlock());
			notifyError(error.message || 'Could not close labour management');
		}
	};

	const closeLabour = id => {
		confirmAction(doCloseLabour, id, `You want to close labour management?`, 'Are you sure?');
	};

	const addNote = () => {
		document.body.classList.add('modal-open');
		setShowNoteModal(true);
	};

	const openProfile = () => {
		document.body.classList.add('modal-open');
		setShowProfileModal(true);
	};

	const doCloseIVF = async item => {
		try {
			const url = `ivf/closeIvf/?ivf_id=${item.id}`;
			const rs = await request(url, 'POST', true);

			// console.log(rs);
			if (rs.success) {
				notifySuccess('Ivf Instance closed successfully');
				setIvfData({ ...item, status: 1 });
			} else {
				notifyError(rs.message);
			}
		} catch (error) {
			console.log(error);
			notifyError('error closing Ivf');
		}
	};

	const doCancelIVF = async item => {
		try {
			const url = `ivf/cancelIvf/?ivf_id=${item.id}`;
			const rs = await request(url, 'POST', true);

			// console.log(rs);
			if (rs.success) {
				notifySuccess('IVF Instance cancelled successfully');
				setIvfData({ ...item, status: 3 });
			} else {
				notifyError(rs.message);
			}
		} catch (error) {
			console.log(error);
			notifyError(error?.message || 'Error cancelling Ivf');
		}
	};

	const doContinueIVF = async item => {
		try {
			const url = `ivf/continueIvf/?ivf_id=${item.id}`;
			const rs = await request(url, 'POST', true);

			// console.log(rs);
			if (rs.success) {
				notifySuccess('IVF Instance re-opened successfully');
				setIvfData({ ...item, status: 0 });
			} else {
				notifyError(rs.message);
			}
		} catch (error) {
			console.log(error);
			notifyError(error?.message || 'Error re-opening Ivf');
		}
	};

	const closeIVF = data => {
		confirmAction(doCloseIVF, data, 'Do you want to close this IVF enrollment?', 'Are you sure?');
	};

	const continueIvf = data => {
		confirmAction(doContinueIVF, data, 'Do you want to continue this IVF enrollment?', 'Are you sure?');
	};

	const cancelIvf = data => {
		confirmAction(doCancelIVF, data, 'Do you want to cancel this IVF enrollment?', 'Are you sure?');
	};

	const handleStatusUpdate = async (ivfId, newStatus, notes) => {
		try {
			let url = '';
			let method = 'POST';

			// Determine which endpoint to use based on status
			if (newStatus === 'success') {
				url = `ivf/markSuccess?ivf_id=${ivfId}`;
			} else if (newStatus === 'failed') {
				url = `ivf/markFailed?ivf_id=${ivfId}`;
			} else if (newStatus === 'discontinue') {
				url = `ivf/discontinueIvf?ivf_id=${ivfId}`;
			} else if (newStatus === 'freeze') {
				url = `ivf/freezeIvf?ivf_id=${ivfId}&freeze_notes=${encodeURIComponent(notes)}`;
			} else {
				notifyError('Invalid status selected');
				return;
			}

			const rs = await request(url, method, true);

			console.log(rs);
			if (rs.success) {
				notifySuccess(`IVF cycle marked as ${newStatus.toUpperCase()} successfully`);
				const statusCode = newStatus === 'discontinue' ? 2 : newStatus === 'freeze' ? 4 : 1;
				setIvfData(prev => ({ ...prev, status: statusCode }));
			} else {
				notifyError(rs.message || `Failed to mark IVF as ${newStatus}`);
			}
		} catch (error) {
			console.log(error);
			notifyError(error?.message || `Error marking IVF as ${newStatus}`);
		}
	};

	const confirmIVFStatusUpdateAction = item => {
		confirmIVFStatusUpdate(handleStatusUpdate, [item], 'Update IVF Status', 'Change IVF Cycle Status');
	};

	const sidepanel = useSelector(state => state.sidepanel);

	const doCloseOpd = async () => {
		try {
			dispatch(startBlock());
			const rs = await request(`patient/out-patient-care/${opdItem.id}/close`, 'PUT', true);
			dispatch(stopBlock());
			if (rs.success) {
				dispatch(toggleSidepanel(true, { ...sidepanel, item: { ...sidepanel.item, status: 1 } }));
				notifySuccess('OPD record closed');
			} else {
				notifyError(rs.message || 'Could not close record');
			}
		} catch (e) {
			dispatch(stopBlock());
			notifyError(e.message || 'Could not close record');
		}
	};

	const closeOpd = () => {
		confirmAction(doCloseOpd, null, 'You want to close this OPD record?', 'Are you sure?');
	};

	return (
		<>
			{patient.refuse_blood_transfusion && (
				<div
					className="alert alert-danger d-flex align-items-center mb-3"
					role="alert"
					style={{ fontWeight: 'bold', fontSize: '15px', borderLeft: '5px solid #dc3545' }}
				>
					<i className="fa fa-exclamation-triangle mr-2" style={{ fontSize: '20px' }} />
					<span>NO BLOOD TRANSFUSION — This patient refuses blood transfusion due to religious/personal beliefs</span>
				</div>
			)}
			<div className="row profile-block">
				<div className="col-md-7 col-lg-8 col-xl-9 col-12">
					<div className="element-box p-3">
						<div className="card-body" style={patient.is_verified ? { backgroundColor: 'rgba(178, 255, 155, 0.26)' } : null}>
							<div className="row">
								<div className="d-flex justify-content-between flex-column col-xl-6 col-21">
									<div className="d-flex justify-content-start">
										<span className="b-avatar badge-light-danger rounded" style={{ width: '104px', height: '104px', cursor: 'pointer' }}>
											<span className="b-avatar-img">
												<img src={parseAvatar(patient.profile_pic)} alt="avatar" onClick={() => setShowImageModal(true)} />
											</span>
										</span>
										{showImageModal && <ViewProfileImage image={patient.profile_pic} closeModal={() => setShowImageModal(false)} />}
										<div className="d-flex flex-column ml-1">
											<div className="mb-1">
												<h4 className="mb-0">
													{patientname(patient)} {patient.is_verified ? <i className="fa fa-check-circle text-success" /> : <></>}
													{patient.admission_id && (
														<Tooltip title="Admitted">
															<i className="fa fa-hospital-o text-danger" />
														</Tooltip>
													)}
													{patient.nicu_id && (
														<Tooltip title="Nicu">
															<i className="fa fa-hospital-o text-danger" />
														</Tooltip>
													)}
												</h4>
												<span className="card-text">{patient?.email}</span>
											</div>

											<div className="d-flex flex-wrap mt-3">
												{hasButtons && (
													<a className="btn btn-primary mr-1" onClick={editPatient}>
														Edit
													</a>
												)}
												{(canAdmit || canDischarge) && patient?.deceased !== true && (
													<DischargeBlock
														patient={patient}
														startDischarge={startDischarge}
														finishDischarge={finishDischarge}
														startNicuDischarge={startNicuDischarge}
														finishNicuDischarge={finishNicuDischarge}
														location={location}
														canAdmit={canAdmit}
														canDischarge={canDischarge}
													/>
												)}
												<Tooltip title="Alerts">
													<a
														className={`${alerts.length > 0 ? 'text-danger' : 'text-success'} relative`}
														style={{ fontSize: '20px', padding: '0 4px' }}
														onClick={() => showAlerts()}
													>
														<i className="fa fa-exclamation-triangle" />
														<span className={`alert-badge ${alerts.length > 0 ? 'text-danger' : 'text-success'}`}>{alerts.length}</span>
													</a>
												</Tooltip>
											</div>
											{canNewNote &&
												(user.role.slug === 'it-admin' ||
													user.role.slug === 'hmo-doctor' ||
													user.role.slug === 'doctor' ||
													user.role.slug === 'medical-director') && (
													<div className="mt-1">
														<button type="button" onClick={() => addNote()} className="btn btn-sm btn-info text-white">
															<i className="os-icon os-icon-ui-22" />
															<span>New Note</span>
														</button>
													</div>
												)}
										</div>
									</div>
									{hasButtons && (
										<div className="d-flex align-items-center mt-2">
											<div className="d-flex align-items-center mr-2">
												<span className="b-avatar badge-light-primary rounded">
													<span className="b-avatar-custom">
														<i className="icon-feather icon-feather-activity" />
													</span>
												</span>
												<div className="ml-1">
													<h5 className="mb-0">{appointmentCount}</h5>
													<small>{appointmentCount <= 1 ? 'Visit' : 'Visits'}</small>
												</div>
											</div>
											<div className="d-flex align-items-center mr-2 pointer">
												{/* <span className="b-avatar badge-light-success rounded">
													<span className="b-avatar-custom">
														<i className="icon-feather icon-feather-credit-card" />
													</span>
												</span> */}
												<Tooltip title="Charges for services already delivered or paid for">
													<div className="ml-1">
														<h6 className="mb-0">{formatCurrency(amount?.balance || 0)}</h6>
														<small className="cursor">Main Balance</small>
													</div>
												</Tooltip>
											</div>
											<div className="d-flex align-items-center mr-2 pointer">
												<Tooltip title="Available wallet/deposit balance (money the patient has funded)">
													<div className="ml-1">
														<h6 className="mb-0">{formatCurrency(amount?.depositBalance || 0)}</h6>
														<small className="cursor">Deposit</small>
													</div>
												</Tooltip>
											</div>
											<div className="mr-2 pointer">
												{amount?.outstanding ? (
													<>
														<div className="mb-0 mt-1" style={{ color: '#e74c3c', fontSize: '0.65rem', fontWeight: 400 }}>
															{formatCurrency(amount.outstanding)}
														</div>
														<Tooltip title="Charges for services booked but not yet delivered">
															<small className="cursor" style={{ color: '#e74c3c' }}>
																Outstanding
															</small>
														</Tooltip>
														<Tooltip title="Balance + Outstanding combined">
															<div className="mb-0 mt-1" style={{ fontSize: '0.65rem', fontWeight: 400 }}>
																{formatCurrency((amount?.balance || 0) + (amount?.outstanding || 0))}
															</div>
															<small className="cursor">Total</small>
														</Tooltip>
													</>
												) : null}
											</div>
										</div>
									)}
								</div>
								<div className="col-xl-6 col-12">
									<table className="mt-4 w-100">
										<tbody>
											<tr>
												<UserItem icon="user" label="Patient ID" value={formatPatientId(patient)} />
											</tr>
											<tr>
												<UserItem icon="user" label="Enrolee ID" value={patient.enrollee_id || '--'} />
											</tr>
											<tr>
												<UserItem icon="user" label="Sex" value={patient?.gender} />
											</tr>
											<tr>
												<UserItem icon="user" label="Phone" value={patient?.phone_number || '--'} />
											</tr>
											{hasViewPatientRecordsPermission(user.permissions) && (
												<tr>
													<UserItem icon="user" label="DOB" value={`${dob} (${getAge(patient?.date_of_birth)})`} />
												</tr>
											)}
											{patient?.nextAppointment && (
												<tr>
													<NextApp
														label={
															moment(patient?.nextAppointment?.appointment_date).isSame(moment(), 'day')
																? 'Appointment (Today)'
																: moment(patient?.nextAppointment?.appointment_date).isBefore(moment(), 'day')
																? 'Last Appointment'
																: 'Next Appointment'
														}
														value={moment(patient?.nextAppointment?.appointment_date).format('dddd, MMMM DD, YYYY')}
													/>
												</tr>
											)}

											{patient && patient.staff && (
												<tr>
													<UserItem icon="user" label="Staff ID" value={patient.staff.id} />
												</tr>
											)}
											{patient.mother && (
												<>
													<tr>
														<UserItem icon="user" label="Mother's Name" value={patientname(patient.mother)} />
													</tr>
													<tr>
														<UserItem icon="user" label="Mother's EMR ID" value={formatPatientId(patient.mother)} />
													</tr>
												</>
											)}
											{admission && admission.room && (
												<tr>
													<UserItem
														icon="user"
														label="Admission Room"
														value={`${admission.room?.category?.name}, Room ${admission.room?.name}`}
													/>
												</tr>
											)}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-5 col-lg-4 col-xl-3 col-12" style={{ paddingLeft: 0 }}>
					<div className="element-box border-primary p-3">
						<div className="card-header align-items-center pt-75 pb-25">
							<div className="d-flex flex-row">
								<h5 className="mb-0">Patient Status</h5>
								{/* If Patient Has Signed */}
								{patient.signature_id && patient.phone_number && patient.email && (
									<Tooltip title="Completed">
										<span className="text-success" style={{ fontSize: '20px', padding: '0 10px' }}>
											<i class="os-icon os-icon-check-circle"></i>
										</span>
									</Tooltip>
								)}
							</div>

							<div className="mt-1 d-flex justify-content-between">
								<div>
									<span className="badge badge-light-primary">{patient.hmo?.name || ''}</span>
								</div>
								{user.role.slug === 'it-admin' && !patient.hasEnrolledOnline && (
									<div>
										<span
											className="btn btn-primary"
											onClick={() => {
												document.body.classList.add('modal-open');
												setEmailModalOpen(true);
											}}
										>
											<i className="fa fa-paper-plane" />
										</span>
									</div>
								)}
							</div>
						</div>
						{ivfData && parseInt(ivfData.status) !== 1 && (
							<div className="card-body mt-2">
								<button type="button" onClick={() => confirmIVFStatusUpdateAction(ivfData)} className="btn btn-block btn-outline-info">
									Mark IVF Outcome
								</button>
							</div>
						)}
						{hasButtons && (
							<div className="card-body">
								{!patient.deceased ? (
									<div className="design-group">
										<ul className="demo-icons-list">
											{(patient?.immunization === undefined || patient?.immunization.length <= 0) && (
												<span className="b-avatar badge-light-primary rounded shiftright post-box">
													<li>
														<a onClick={enrollImmunization}>
															<i className="picons-thin-icon-thin-0811_medicine_health_injection_ill" />
															<span>immunization</span>
														</a>
													</li>
												</span>
											)}
											{!patient.admission_id && (
												<span className="b-avatar badge-light-primary rounded shiftright post-box">
													<li>
														<Link to={`${location.pathname}#start-admission`}>
															<i className="picons-thin-icon-thin-0821_blood_infusion" />
															<span>admission</span>
														</Link>
													</li>
												</span>
											)}
											<span className="b-avatar badge-light-primary rounded shiftright post-box">
												<li>
													<Link to={`${location.pathname}#enroll-ivf`}>
														<i className="picons-thin-icon-thin-0816_microscope_laboratory" />
														<span>IVF</span>
													</Link>
												</li>
											</span>
											<span className="b-avatar badge-light-primary rounded shiftright post-box">
												<li>
													<Link to={`${location.pathname}#enroll-antenatal`}>
														<i className="picons-thin-icon-thin-0813_heart_vitals_pulse_rate_health" />
														<span>Antenatal</span>
													</Link>
												</li>
											</span>
											<span className="b-avatar badge-light-primary rounded shiftright post-box">
												<li>
													<a onClick={openProfile}>
														<i className="picons-thin-icon-thin-0708_user_profile" />
														<span>Profile</span>
													</a>
												</li>
											</span>
											{['it-admin', 'medical-director', 'doctor'].includes(user.role?.slug) && (
												<span className="b-avatar badge-light-primary rounded shiftright post-box">
													{/* <li>
														<a onClick={toggleBloodTransfusion}>
															<i className="picons-thin-icon-thin-0708_user_profile" />
															<span>{patient.refuse_blood_transfusion ? 'Remove Blood Transfusion Restriction' : 'Blood Transfusion'}</span>
														</a>
													</li> */}
													<li>
														<a onClick={toggleBloodTransfusion} className="d-flex align-items-center">
															{patient.refuse_blood_transfusion ? (
																<>
																	<Droplets size={18} className="me-2 text-success" />
																	<span>Remove Blood Transfusion Restriction</span>
																</>
															) : (
																<>
																	<Droplets size={18} className="me-2 text-danger" />
																	<span>Blood Transfusion Restriction</span>
																</>
															)}
														</a>
													</li>
												</span>
											)}
										</ul>
									</div>
								) : (
									<h6>
										<i className="fa fa-skull g-3 m-3 font-sm text-danger" /> Patient is Deceased
									</h6>
								)}
								{(user.role.slug === 'it-admin' || user.role.slug === 'medical-director') && (
									<>
										{patient.is_active ? (
											<button type="button" onClick={() => confirm('disable')} className="btn btn-block btn-outline-danger">
												Disable Patient
											</button>
										) : (
											<button type="button" onClick={() => confirm('enable')} className="btn btn-block btn-outline-info">
												Enable Patient
											</button>
										)}
									</>
								)}

								{(user.role.slug === 'it-admin' || user.role.slug === 'medical-director') && (
									<>
										{patient.deceased ? (
											// <button type="button" onClick={() => deceasedAction('alive')} className="btn btn-block btn-outline-danger">
											// 	Mark as Alive
											// </button>
											<button type="button" className="btn btn-block btn-outline-danger">
												Deceased
											</button>
										) : (
											<button type="button" onClick={() => deceasedAction('deceased')} className="btn btn-block btn-outline-info">
												Mark as Deceased
											</button>
										)}
									</>
								)}
								{/* {['doctor', 'it-admin', 'medical-director'].includes(user.role?.slug) && (
									<button
										type="button"
										onClick={toggleBloodTransfusion}
										className={`btn btn-block ${patient.refuse_blood_transfusion ? 'btn-danger' : 'btn-outline-warning text-danger'}`}
									>
										<i className={`fa ${patient.refuse_blood_transfusion ? 'fa-times-circle' : 'fa-ban'} mr-1`} />
										{patient.refuse_blood_transfusion ? 'Remove Blood Transfusion Restriction' : 'Blood Transfusion'}
									</button>
								)} */}

								{patient.antenatal_id && hasCloseAncPermission(user.permissions) && (
									<button type="button" onClick={() => closeAnc(patient.antenatal_id)} className="btn btn-block btn-outline-danger">
										Close Antenatal
									</button>
								)}
								{patient.labour_id && hasCloseLabourPermission(user.permissions) && (
									<button type="button" onClick={() => closeLabour(patient.labour_id)} className="btn btn-block btn-outline-danger">
										{`${patient?.labourStatus === 'nurse' ? 'Initiate close Labour Mgt' : 'Close Labour Mgt'}`}
									</button>
								)}
							</div>
						)}
						{!hasButtons && (
							<div className="card-body mt-2">
								{patient.antenatal_id && hasCloseAncPermission(user.permissions) && (
									<button type="button" onClick={() => closeAnc(patient.antenatal_id)} className="btn btn-block btn-outline-danger">
										Close Antenatal
									</button>
								)}
								{patient.labour_id && hasCloseLabourPermission(user.permissions) && (
									<button type="button" onClick={() => closeLabour(patient.labour_id)} className="btn btn-block btn-outline-danger">
										{`${patient?.labourStatus === 'nurse' ? 'Initiate close Labour Mgt' : 'Close Labour Mgt'}`}
									</button>
								)}
								{opdItem && opdItem.status === 0 && (
									<button type="button" onClick={closeOpd} className="btn btn-block btn-outline-danger">
										Close OPD Record
									</button>
								)}
							</div>
						)}
						{ivfData ? (
							<div className="card-body mt-2">
								{hasCloseIVFPermission(user.permissions) && parseInt(ivfData.status) === 0 && (
									<button type="button" onClick={() => closeIVF(ivfData)} className="btn btn-block btn-outline-success">
										Close IVF
									</button>
								)}
								{parseInt(ivfData.status) === 2 && (
									<button type="button" onClick={() => continueIvf(ivfData)} className="btn btn-block btn-outline-secondary">
										Continue IVF
									</button>
								)}
								{hasCancelIVFPermission(user.permissions) && parseInt(ivfData.status) === 0 && (
									<button type="button" onClick={() => cancelIvf(ivfData)} className="btn btn-block btn-outline-danger">
										Cancel IVF
									</button>
								)}
								{/* {parseInt(ivfData.status) === 4 && (
									<button type="button" onClick={() => continueIvf(ivfData)} className="btn btn-block btn-outline-secondary">
										Continue IVF
									</button>
								)} */}
							</div>
						) : (
							<div></div>
						)}
					</div>
				</div>
			</div>
			{bloodTransfusionAlertShown && patient.refuse_blood_transfusion && (
				<div className="onboarding-modal modal fade animated show" role="dialog" style={{ display: 'block' }}>
					<div className="modal-dialog modal-centered modal-sm">
						<div className="modal-content" style={{ border: '3px solid #dc3545' }}>
							<div className="modal-body text-center p-4">
								<i className="fa fa-exclamation-triangle text-danger" style={{ fontSize: '48px' }} />
								<h4 className="text-danger mt-3 mb-2" style={{ fontWeight: 'bold' }}>
									NO BLOOD TRANSFUSION
								</h4>
								<p className="mb-3">
									<strong>{patientname(patient)}</strong> refuses blood transfusion due to religious/personal beliefs.
								</p>
								<button className="btn btn-danger btn-block" onClick={() => setBloodTransfusionAlertShown(false)}>
									I Understand
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
			{showModal && <ViewAlerts patient={patient} closeModal={closeModal} />}
			{(admissionDischarge || nicuDischarge) && patient && (
				<ModalDischargePatient
					admissionId={admissionId}
					nicuId={nicuId}
					onSubmit={onSubmitDischargeNote}
					closeModal={() => closeDischarge()}
					type={dischargeType}
				/>
			)}
			{showDischargeStatusModal && patient && (
				<ModalDischargeStatus closeModal={() => closeDischarge()} confirmDischarge={confirmDischargeStatus} />
			)}
			{(admissionFinishDischarge || nicuFinishDischarge) && patient && (
				<ModalFinishDischarge
					patient={patient}
					admissionId={admissionId}
					nicuId={nicuId}
					finishDischarge={onCompleteDischarge}
					closeModal={() => closeDischarge()}
					type={dischargeType}
				/>
			)}
			{showImmunizationModal && (
				<EnrollImmunizationModal
					show={showImmunizationModal}
					onClose={() => {
						setShowImmunizationModal(false);
						setImmunizationStartDate(null);
						document.body.classList.remove('modal-open');
					}}
					onConfirm={onEnrollImmunization}
					patientName={patientname(patient)}
					startDate={startDate}
					setStartDate={setStartDate}
				/>
			)}
			{editModal && <PatientForm patient={patient} closeModal={() => closeModal()} />}
			{showNoteModal && <CreateNote closeModal={closeModal} updateNote={() => {}} patient={patient} type="consultation" />}
			{showProfileModal && patient && <PatientProfile patient={patient} closeModal={closeModal} />}
			{emailModalOpen && patient && (
				<SendUpdateLink
					closeModal={() => {
						document.body.classList.remove('modal-open');
						setEmailModalOpen(false);
					}}
					patient={patient}
					updatePatient={pat => {
						setPatient(pat);
					}}
				/>
			)}
		</>
	);
};

export default withRouter(ProfileBlock);
